import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CognitoUser } from 'amazon-cognito-identity-js';

import { AuthMode } from './auth.component';

@Component({
  selector: 'fc-abstract-auth',
  template: '',
})
export class AbstractAuthComponent {
  authModeEnum = AuthMode;
  cognitoError: boolean = false;
  errorMessage: string = '';
  _authMode?: AuthMode;
  _cognitoUser?: CognitoUser;
  _email?: string;
  _isFormDirty?: boolean;
  _password?: string;

  @Output() authModeChange = new EventEmitter<AuthMode>();
  @Output() cognitoUserChange = new EventEmitter<CognitoUser | undefined>();
  @Output() emailChange = new EventEmitter<string | undefined>();
  @Output() isFormDirtyChange = new EventEmitter<boolean>();
  @Output() passwordChange = new EventEmitter<string | undefined>();

  constructor() {}

  @Input() get authMode(): AuthMode | undefined {
    return this._authMode;
  }

  set authMode(val: AuthMode | undefined) {
    this._authMode = val;
    this.authModeChange.emit(this._authMode);
  }

  @Input() get cognitoUser(): CognitoUser | undefined {
    return this._cognitoUser;
  }

  set cognitoUser(val: CognitoUser | undefined) {
    this._cognitoUser = val;
    this.cognitoUserChange.emit(this._cognitoUser);
  }

  @Input() get email(): string | undefined {
    return this._email;
  }

  set email(val: string | undefined) {
    this._email = val;
    this.emailChange.emit(this._email);
  }

  @Input() get isFormDirty(): boolean | undefined {
    return this._isFormDirty;
  }

  set isFormDirty(val: boolean | undefined) {
    this._isFormDirty = val;
    this.isFormDirtyChange.emit(this._isFormDirty);
  }

  @Input() get password(): string | undefined {
    return this._password;
  }

  set password(val: string | undefined) {
    this._password = val;
    this.passwordChange.emit(this._password);
  }
}
